var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEyeSquared(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01-MyClients-documentList-gridView-(coach)",
    transform: "translate(-1151.000000, -580.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#F3F3F3",
    x: 0,
    y: 0,
    width: 1470,
    height: 945
  }), /*#__PURE__*/React.createElement("g", {
    id: "btn-show",
    transform: "translate(1151.000000, 580.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F3F3F3",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "ic-view",
    transform: "translate(10.000000, 13.000000)",
    stroke: "#646464",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,6.75 C0,6.75 4.725,0 10.5,0 C16.2,0 21,6.75 21,6.75 C21,6.75 16.2,13.5 10.5,13.5 C4.8,13.5 0,6.75 0,6.75 L0,6.75 Z",
    id: "Stroke-298"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5,3 C12.57075,3 14.25,4.67925 14.25,6.75 C14.25,8.82075 12.57075,10.5 10.5,10.5 C8.42925,10.5 6.75,8.82075 6.75,6.75 C6.75,4.67925 8.42925,3 10.5,3 L10.5,3 Z",
    id: "Stroke-299"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEyeSquared);
export default __webpack_public_path__ + "static/media/ic-eye-squared.ab20d2dd953811fac4664d9d318005ce.svg";
export { ForwardRef as ReactComponent };